import { client } from "../../../../api/client";

const parseObjectField = (value) => {
  if (value === null || value === undefined || value === "") return {};

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }

  if (typeof value === "object" && !Array.isArray(value)) {
    return value;
  }

  return {};
};

const parseArrayField = (value) => {
  if (value === null || value === undefined || value === "") return [];

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [];
};

const stringifyPreviewSectionValues = (value) => JSON.stringify(parseObjectField(value));

const stringifyIfObject = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "string") return value;
  return JSON.stringify(value);
};

const normalizeTemplateFromApi = (item) => {
  if (!item || typeof item !== "object") return item;

  return {
    ...item,
    configJson: parseObjectField(item.configJson),
    customFields: parseArrayField(item.customFields),
    customSections: parseArrayField(item.customSections),
    customFieldsLayout: parseArrayField(item.customFieldsLayout),
    previewSectionValues: parseObjectField(item.previewSectionValues),
  };
};

const normalizeTemplateResponse = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => normalizeTemplateFromApi(item));
  }

  if (data && typeof data === "object" && Array.isArray(data.exportTemplateItems)) {
    return {
      ...data,
      exportTemplateItems: data.exportTemplateItems.map((item) => normalizeTemplateFromApi(item)),
    };
  }

  return normalizeTemplateFromApi(data);
};

export const fetchExportTemplate = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate");
      return normalizeTemplateResponse(response.data);
    } catch (error) {
      console.error("Error fetching export template:", error);
      return [];
    }
  }
}

export const fetchExportTemplateDropdown = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_exportTemplateData.json");
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/dropdown");
            if(response.ok)
                return response.data;
            else {
                console.error("Error getting export template dropdown", response.data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching export template dropdown:", error);
            return [];
        }
    }
}

export const fetchExportTemplateById = async (id) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`);
      return normalizeTemplateResponse(response.data);
    } catch (error) {
      console.error("Error fetching export template by id:", error);
      return [];
    }
  }
}

export const fetchExportTemplateByFilter = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    const exportTemplateItems = require("./_local/_exportTemplateData.json");
    return normalizeTemplateResponse({
      exportTemplateItems,
      totalRecords: exportTemplateItems.length,
    });
  } else {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/filter", body);
      return normalizeTemplateResponse(response.data);
    } catch (error) {
      console.error("Error fetching export template by filter:", error);
      return [];
    }
  }
}

export const fetchExportTemplatesToRunOnQuoteCreation = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_exportTemplateData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate/GetExportTemplatesToRunOnQuoteCreation");
      return response.data;
    } catch (error) {
      console.error("Error fetching export templates to run on quote creation:", error);
      return [];
    }
  }
}

const normalizeSaveBody = (body) => {
  if (!body || typeof body !== "object") return body;

  return {
    ...body,
    configJson: stringifyIfObject(body.configJson),
    customFields: stringifyIfObject(body.customFields),
    customSections: stringifyIfObject(body.customSections),
    customFieldsLayout: stringifyIfObject(body.customFieldsLayout),
    previewSectionValues: stringifyPreviewSectionValues(body.previewSectionValues),
  };
};

export const createExportTemplate = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/exporttemplate", normalizeSaveBody(body));
      return response.data;
    } catch (error) {
      console.error("Error creating export template:", error);
      return null;
    }
  } else {
    return { "data": { newId: Math.floor(Math.random() * 100000) } };
  }
};

export const deleteExportTemplate = async (id) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      await client.delete(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`);
    } catch (error) {
      console.error("Error deleting export template:", error);
    }
  }
};


export const updateExportTemplate = async (id, body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
      const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `templatesapi/exporttemplate/${id}`, normalizeSaveBody(body));
      return response.data;
    } catch (error) {
      console.error("Error updating export template:", error);
    }
  }
};

export const exportTemplate = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") return null;
    try {
        const response = await client.post(
            process.env.REACT_APP_GATEWAY_URI,
            "templatesapi/exporttemplate/exporttemplate",
            body // JSON in
            // If your client supports a 4th options arg and you need it, add:
            // , { responseType: "arraybuffer" }
        );
        // File bytes out – same as exportItems
        console.log("response", response);
        return response.data;
    } catch (error) {
        console.error("Error testing export template:", error);
        return null;
    }
}


export const testExportTemplate = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "true") return null;

  try {
    // Same 3-arg signature your client uses elsewhere
    console.log('testExportTemplate body', body);
    
    const response = await client.post(
      process.env.REACT_APP_GATEWAY_URI,
      "templatesapi/exporttemplate/test",
      body // JSON in
      // If your client supports a 4th options arg and you need it, add:
      // , { responseType: "arraybuffer" }
    );
    // File bytes out – same as exportItems
    return response.data;
  } catch (error) {
    console.error("Error testing export template:", error);
    return null;
  }
};
